export const init_select2 = function() {
  const select2ChosenEvent = new CustomEvent("select2Chosen", {bubbles: true});

  let selects = $('select.select2').not(".select2-hidden-accessible");
  selects.select2({
    theme: 'bootstrap4',
    minimumInputLength: 0,
    selectOnClose: false,
    ajax: {
      dataType: 'json',
      delay: 250,
      data: function (params) {
        var query = {
          q: params.term,
          page: params.page,
        }
        return query;
      },

      processResults: function (data, params) {
        params.page = data.current_page || 1;
        return {
          results: data.items,
          pagination: {
            // Does not seem to work - 20thMay
            // Just sends instant requests for more data until all data is supplied, then stops. Should really only request when users scrolls
            //more: data.current_page < data.total_pages
            more: false
          }
        };

      },
      cache: true
    },
  });

  selects.on('change', e => e.target.dispatchEvent(select2ChosenEvent))

  Array.from(
    selects
  ).forEach( (s) => {  
    let jqS2 = $(`#${s.id}`);
    if ( s.attributes['data-currenttext'] !== undefined ) {
      let opt = new Option(
        s.attributes['data-currenttext'].value,
        s.attributes['data-currentvalue'].value,
        true, 
        true
      );
      jqS2.append(opt).trigger('change');
    }
  })

}